/** Valor em reais (pt-BR), usado na tela, nos totais e nas opções dos diálogos. */
export const formatCurrency = (value) =>
  new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value || 0);

/** Arredondamento dos campos de texto do formulário (mesmo raio dos popups redesenhados). */
export const roundedFieldSx = {
  '& .MuiOutlinedInput-root': { borderRadius: '10px', background: '#FFFFFF' },
};
